<header mat-dialog-title class="u-flex-full">
  <span>
    {{'risks.Seleziona categoria' | translate}}
  </span>
</header>
<mat-dialog-content>
  <risk-category-list [riskCategories]="riskCategories" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectRiskCategory)="selectRiskCategory($event)"></risk-category-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
